import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import Trigger from '../vc-trigger';
import SelectTag from './SelectTag';
import SelectList from './SelectList';
import CascaderProps from './CascaderPropTypes';
import { getComponentFromProp } from '../_util/props-util';
import LocaleReceiver from '../locale-provider/LocaleReceiver';

var SelectPopup = {
  mixins: [BaseMixin],
  props: _extends({}, CascaderProps, {
    prefixCls: PropTypes.string.def('rc-select-list'),
    popupPlacement: PropTypes.string.def('top'),
    builtinPlacements: PropTypes.object,
    selectorValueList: PropTypes.array,
    height: PropTypes.number,
    showType: PropTypes.oneOf(['tag', 'list']).def('tag')
  }),

  data: function data() {
    return {
      _popupVisible: false
    };
  },


  methods: {
    removeSelected: function removeSelected(event, item) {
      this.__emit('remove', event, item);
    },
    handlePopupVisibleChange: function handlePopupVisibleChange(popupVisible) {
      this.setPopupVisible(popupVisible);
    },
    setPopupVisible: function setPopupVisible(popupVisible) {
      this.setState({ _popupVisible: popupVisible });
    },
    renderPopup: function renderPopup(locale) {
      var h = this.$createElement;
      var $props = this.$props,
          removeSelected = this.removeSelected,
          handlePopupVisibleChange = this.handlePopupVisibleChange;
      var disabled = $props.disabled,
          prefixCls = $props.prefixCls,
          height = $props.height,
          showType = $props.showType,
          transitionName = $props.transitionName,
          popupPlacement = $props.popupPlacement,
          builtinPlacements = $props.builtinPlacements,
          selectorValueList = $props.selectorValueList;
      var popupVisible = this.$data._popupVisible;


      var selectListPrefixCls = prefixCls + '-list';
      // const removeIcon = getComponentFromProp(this, 'removeIcon');

      /** 触发器 */
      var triggerProps = {
        props: {
          disabled: disabled,
          popupPlacement: popupPlacement,
          builtinPlacements: builtinPlacements,
          popupTransitionName: transitionName,
          popupVisible: disabled ? false : popupVisible,
          action: disabled ? [] : ['click'],
          prefixCls: selectListPrefixCls,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        },
        on: {
          popupVisibleChange: handlePopupVisibleChange
        }
      };

      var selectTagProps = {
        props: _extends({}, $props, {
          prefixCls: prefixCls
        }),
        on: {
          remove: removeSelected
        }
      };

      var closeIcon = getComponentFromProp(this, 'closeIcon');
      closeIcon = Array.isArray(closeIcon) ? closeIcon[0] : closeIcon;

      return h(
        Trigger,
        triggerProps,
        [h(
          'div',
          { 'class': prefixCls + '-text' },
          [locale.selected, '(', selectorValueList.length, ')']
        ), h(
          'div',
          { slot: 'popup', 'class': selectListPrefixCls + '-selection--multiple' },
          [h(
            'div',
            { 'class': selectListPrefixCls + '-header' },
            [h(
              'div',
              { 'class': selectListPrefixCls + '-header-inner' },
              [locale.selected]
            ), h(
              'div',
              {
                'class': selectListPrefixCls + '-close',
                on: {
                  'click': function click() {
                    return handlePopupVisibleChange(false);
                  }
                }
              },
              [closeIcon || h(
                'i',
                { 'class': prefixCls + '-selection__choice__remove-icon' },
                ['\xD7']
              )]
            )]
          ), h(
            'div',
            {
              'class': [selectListPrefixCls + '-body', _defineProperty({}, prefixCls + '-selection__rendered', showType === 'tag')],
              style: { height: height ? height + 'px' : '' }
            },
            [showType === 'tag' && h(SelectTag, selectTagProps), showType === 'list' && h(SelectList, selectTagProps)]
          )]
        )]
      );
    }
  },

  render: function render() {
    var h = arguments[0];

    return h(LocaleReceiver, {
      attrs: { componentName: 'Cascader' },
      scopedSlots: { 'default': this.renderPopup } });
  }
};

export default SelectPopup;